import HighlightedLinkList from './highlighted-link-list';

export default HighlightedLinkList;
